import { render, staticRenderFns } from "./BackbarPageLayout.vue?vue&type=template&id=ae7c38dc&scoped=true&"
import script from "./BackbarPageLayout.vue?vue&type=script&lang=js&"
export * from "./BackbarPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./BackbarPageLayout.vue?vue&type=style&index=0&id=ae7c38dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7c38dc",
  null
  
)

export default component.exports